"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContentClient = void 0;
var config_1 = require("../config");
var createContentClientV2Fresh_1 = require("./createContentClientV2Fresh");
var createBaseContentClient_1 = require("./createBaseContentClient");
/**
 * Create network client to make requests to the content delivery service
 * @param config
 * @hidden
 */
function createContentClient(config) {
    if ((0, config_1.isContentClientConfigV2Fresh)(config)) {
        return (0, createContentClientV2Fresh_1.createContentClientV2Fresh)(config, "https://".concat(config.hubName, ".fresh.content.amplience.net"));
    }
    if ((0, config_1.isContentClientConfigV2)(config)) {
        return (0, createBaseContentClient_1.createBaseContentClient)(config, "https://".concat(config.hubName, ".cdn.content.amplience.net"));
    }
    return (0, createBaseContentClient_1.createBaseContentClient)(config, 'https://cdn.c1.amplience.net');
}
exports.createContentClient = createContentClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlQ29udGVudENsaWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvY2xpZW50L2NyZWF0ZUNvbnRlbnRDbGllbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0Esb0NBSW1CO0FBQ25CLDJFQUEwRTtBQUMxRSxxRUFBb0U7QUFFcEU7Ozs7R0FJRztBQUNILFNBQWdCLG1CQUFtQixDQUNqQyxNQUFrQztJQUVsQyxJQUFJLElBQUEscUNBQTRCLEVBQUMsTUFBTSxDQUFDLEVBQUU7UUFDeEMsT0FBTyxJQUFBLHVEQUEwQixFQUMvQixNQUFNLEVBQ04sa0JBQVcsTUFBTSxDQUFDLE9BQU8saUNBQThCLENBQ3hELENBQUM7S0FDSDtJQUVELElBQUksSUFBQSxnQ0FBdUIsRUFBQyxNQUFNLENBQUMsRUFBRTtRQUNuQyxPQUFPLElBQUEsaURBQXVCLEVBQzVCLE1BQU0sRUFDTixrQkFBVyxNQUFNLENBQUMsT0FBTywrQkFBNEIsQ0FDdEQsQ0FBQztLQUNIO0lBRUQsT0FBTyxJQUFBLGlEQUF1QixFQUFDLE1BQU0sRUFBRSw4QkFBOEIsQ0FBQyxDQUFDO0FBQ3pFLENBQUM7QUFsQkQsa0RBa0JDIn0=